import React from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";

const UpcominMatches = () => {
    const { t} = useTranslation();
    const navigate = useNavigate();
    const { language } = useSelector((state) => state.language);

    const upcomingMatches = [
			{
				time: "12:30",
				date: "26 Aug",
				teams: [
					{
						name: "Paris Saint-Germain",
						logo: require("../../../assets/images/clubs/paris.png"),
					},
					{
						name: "Stade Brestois 29",
						logo: require("../../../assets/images/clubs/sb29.png"),
					},
				],
			},
			{
				time: "14:00",
				date: "27 Aug",
				teams: [
					{
						name: "Racing Club de Lens",
						logo: require("../../../assets/images/clubs/rcl.png"),
					},
					{
						name: "Olympique Lyonnais",
						logo: require("../../../assets/images/clubs/rfef.png"),
					},
				],
			},

			{
				time: "18:00",
				date: "28 Aug",
				teams: [
					{
						name: "Olympique de Marseille",
						logo: require("../../../assets/images/clubs/fff.png"),
					},
					{
						name: "AS Monaco",
						logo: require("../../../assets/images/clubs/paris.png"),
					},
				],
			},
			{
				time: "20:45",
				date: "29 Aug",
				teams: [
					{
						name: "LOSC Lille",
						logo: require("../../../assets/images/clubs/paris.png"),
					},
					{
						name: "FC Nantes",
						logo: require("../../../assets/images/clubs/rfef.png"),
					},
				],
			},
			{
				time: "16:00",
				date: "30 Aug",
				teams: [
					{
						name: "Stade Rennais FC",
						logo: require("../../../assets/images/clubs/fff.png"),
					},
					{
						name: "OGC Nice",
						logo: require("../../../assets/images/clubs/paris.png"),
					},
				],
			},
		];


  return (
    <>
		<div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
			<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
					<h3 className="xl:text-lg text-base font-extrabold uppercase">{t('upcomingMatches')}</h3>
					<Link to={'../upcoming-matches'} className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
			</div>
			<div className="panel-body w-full">
				<div class="overflow-x-auto">
					<table class="table table-row-hover w-full">
					{/* <thead class="border-b light-border">
						<tr>
						<th>{t("time")}</th>
						<th>{t("teams")}</th>
						</tr>
					</thead> */}

					<tbody class="divide-y divide-gray-200 [&_tr_td]:align-top">
						{upcomingMatches.map((match, index) => {
						// Auto Trend Logic
						const trendClass = match.points > 5 ? "up" : "down";

						return (
							<tr key={index} className='cursor-pointer'>
							<td width="24">
								<p className="time text-xs font-secondary text-nowrap">
								{match.time}
								</p>
								<p className="date text-xs font-secondary text-nowrap text-gray-500">
								{match.date}
								</p>
							</td>

							<td>
								<div
								className="flex max-sm:flex-wrap items-center gap-3"
								// onClick={() => navigate(`/${language}/fixtures/history`)}
								>
								<ul className="flex -space-x-2 rtl:space-x-reverse">
									{match.teams.map((team, teamIndex) => (
									<li
										key={teamIndex}
										className="p-1 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white"
									>
										<img
										className="size-7 object-contain dark:border-gray-800"
										src={team.logo}
										alt={team.name}
										/>
									</li>
									))}
								</ul>
								<div>
									<p className="uppercase">{match.teams[0].name}</p>
									<p className="uppercase text-gray-400">
									{match.teams[1].name}
									</p>
								</div>
								</div>
							</td>
							</tr>
						);
						})}
					</tbody>
					</table>
				</div>
			</div>
		</div>
    </>
  )
}

export default UpcominMatches